export const MAX_ORDER_DEFAULT = 8;
